import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { webAuth } from '../api/client';

export default function ForgotPasswordScreen() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await webAuth.forgotPassword(email);
      setSubmitted(true);
    } catch {
      setError('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (submitted) {
    return (
      <div style={s.container}>
        <div style={s.card}>
          <div style={s.icon}>📧</div>
          <h2 style={s.title}>Check your email</h2>
          <p style={s.text}>
            If an account exists for <strong>{email}</strong>, we sent a password reset link.
            Check your inbox and spam folder.
          </p>
          <Link to="/login" style={s.button}>Back to Sign In</Link>
        </div>
      </div>
    );
  }

  return (
    <div style={s.container}>
      <div style={s.card}>
        <h1 style={s.title}>Forgot Password</h1>
        <p style={s.subtitle}>Enter your email and we'll send you a reset link.</p>

        {error && <div style={s.error}>{error}</div>}

        <form onSubmit={handleSubmit}>
          <div style={s.field}>
            <label style={s.label}>Email Address</label>
            <input
              style={s.input}
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@example.com"
              required
            />
          </div>

          <button style={loading ? s.buttonDisabled : s.button} type="submit" disabled={loading}>
            {loading ? 'Sending...' : 'Send Reset Link'}
          </button>
        </form>

        <div style={s.divider} />
        <p style={s.bottomText}><Link to="/login" style={s.link}>Back to Sign In</Link></p>
      </div>
    </div>
  );
}

const s = {
  container:    { minHeight: '100vh', backgroundColor: '#f0f2f5', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 },
  card:         { backgroundColor: '#fff', padding: '40px', borderRadius: '12px', boxShadow: '0 4px 20px rgba(0,0,0,0.1)', width: '100%', maxWidth: '400px', textAlign: 'center' },
  title:        { fontSize: '28px', fontWeight: 'bold', color: '#1a1a2e', margin: '0 0 8px 0' },
  subtitle:     { color: '#666', fontSize: '14px', marginBottom: '28px' },
  icon:         { fontSize: 48, marginBottom: 16 },
  text:         { color: '#555', fontSize: 15, lineHeight: 1.6, marginBottom: 24 },
  field:        { marginBottom: '20px', textAlign: 'left' },
  label:        { display: 'block', marginBottom: '6px', fontWeight: '600', fontSize: '14px', color: '#333' },
  input:        { width: '100%', padding: '12px', borderRadius: '8px', border: '1px solid #ddd', fontSize: '16px', boxSizing: 'border-box', outline: 'none' },
  button:       { display: 'block', width: '100%', padding: '14px', backgroundColor: '#1a1a2e', color: '#fff', border: 'none', borderRadius: '8px', fontSize: '16px', fontWeight: '600', cursor: 'pointer', textDecoration: 'none', textAlign: 'center', boxSizing: 'border-box' },
  buttonDisabled: { width: '100%', padding: '14px', backgroundColor: '#999', color: '#fff', border: 'none', borderRadius: '8px', fontSize: '16px', fontWeight: '600', cursor: 'not-allowed' },
  error:        { backgroundColor: '#ffe0e0', color: '#cc0000', padding: '12px', borderRadius: '8px', marginBottom: '20px', fontSize: '14px' },
  divider:      { borderTop: '1px solid #eee', margin: '24px 0' },
  bottomText:   { color: '#666', fontSize: '14px' },
  link:         { color: '#007AFF', textDecoration: 'none' },
};